import type {ID, Nullable} from '../../../../utils/utility-types';
import type {UserModel} from '../../../domain/User/User.model';

export abstract class FetchUserQuery {
  abstract exec(props: FetchUserQuery.Props): Promise<Nullable<UserModel>>;
}

export namespace FetchUserQuery {
  export type Props = {
    id: ID;
  };
}
